var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessRequestImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 117,
    viewBox: "0 0 276 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1146 113C29.1146 113 24.467 78.1658 40.7335 67.6095C54.8982 58.4146 66.6806 52.8306 90.6931 52.1268C114.706 51.423 127.87 51.4195 142.202 36.9978C156.534 22.5761 175.911 0.784383 197.58 0.0523349C218.494 -0.654958 231.273 5.32874 243.277 47.5541C255.282 89.7796 242.888 111.592 242.499 111.943C242.23 112.194 29.1146 113 29.1146 113Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9781_41209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5 99C156.173 99 170.5 84.6731 170.5 67C170.5 49.3269 156.173 35 138.5 35C120.827 35 106.5 49.3269 106.5 67C106.5 84.6731 120.827 99 138.5 99Z",
    fill: "#4CAF50",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.498 92.6004C152.637 92.6004 164.098 81.1389 164.098 67.0004C164.098 52.8619 152.637 41.4004 138.498 41.4004C124.36 41.4004 112.898 52.8619 112.898 67.0004C112.898 81.1389 124.36 92.6004 138.498 92.6004Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.707 59.8642L135.968 77.4667C135.414 78.0169 134.687 78.292 133.963 78.292C133.238 78.292 132.506 78.015 131.95 77.4592L122.533 68.0442C121.421 66.9326 121.421 65.1323 122.533 64.0206C123.645 62.909 125.447 62.909 126.557 64.0206L133.968 71.4323L149.695 55.8255C150.81 54.7195 152.612 54.7252 153.718 55.8406C154.824 56.9561 154.818 58.7583 153.703 59.8642H153.707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9781_41209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(106.5 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRequestImage);
export default __webpack_public_path__ + "static/media/successRequestImage.19a21c788deac2714cef0ae65f61e2f8.svg";
export { ForwardRef as ReactComponent };